/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Form, FormInstance, Input } from 'antd';

import { ClearTelemetry, ClearTelemetryData } from '@/client';
import { ValidationError } from '@/components/Forms/ValidationError';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { tokens } from '@/theme';

const requiredMarkAfter = (label: React.ReactNode) => label;

export type ClearTelemetryFormParams = {
  telemetryType: ClearTelemetryData['telemetryType'];
  form: FormInstance<ClearTelemetry>;
};

export function ClearTelemetryForm({ telemetryType, form }: ClearTelemetryFormParams) {
  const { t } = useMimicTranslation('node');

  return (
    <Form
      validateTrigger="onBlur"
      form={form}
      layout="vertical"
      requiredMark={requiredMarkAfter}
      data-testid="clear-hallmarks-form"
    >
      <Form.Item
        name="reason"
        label={t('clearTelemetryModal.reason')}
        rules={[
          { required: true, message: <ValidationError>{t('clearTelemetryModal.enterValidReason')}</ValidationError> },
          {
            min: 10,
            message: <ValidationError>{t('clearTelemetryModal.enterValidReasonLength', { min: 10 })}</ValidationError>,
          },
        ]}
      >
        <Input.TextArea
          allowClear
          rows={4}
          placeholder={t(`clearTelemetryModal.${telemetryType}.reasonPlaceholder`)}
          data-testid="clear-telemetry-reason"
          count={{ show: true, max: 280 }}
          maxLength={280}
          style={{
            backgroundColor: tokens.color.surface.surfaceHigh,
          }}
        />
      </Form.Item>
    </Form>
  );
}
